import FormattedMessage from 'I18n/components/FormattedMessage';
import unescapedText from 'I18n/utils/unescapedText';
import { Tab, Tabs } from 'foundations-components/transitional/components/Tabs';
import { useCallback, useMemo } from 'react';
import { DetailsTab } from '../../info/DetailsTab';
import { LegalTab } from '../../info/LegalTab';
import { SupportTab } from '../../info/SupportTab';
import { DetailsPageCard } from './DetailsPageCard';
import { useDetailsPageContext } from '../../context/DetailsPageContext';
import { jsx as _jsx } from "react/jsx-runtime";
export function ProductInfoCard({
  details,
  support,
  legal
}) {
  const {
    trackInteraction
  } = useDetailsPageContext();
  const handleTrackInteraction = useCallback(eventProps => {
    trackInteraction(Object.assign({
      section: 'product info card'
    }, eventProps));
  }, [trackInteraction]);
  const tabs = useMemo(() => {
    var _details$category, _details$languages;
    const tabsArray = [];
    if (details !== null && details !== void 0 && (_details$category = details.category) !== null && _details$category !== void 0 && _details$category.length || details !== null && details !== void 0 && (_details$languages = details.languages) !== null && _details$languages !== void 0 && _details$languages.length) {
      tabsArray.push({
        tabId: 'details',
        title: unescapedText('detailsPage.infoCard.details'),
        content: /*#__PURE__*/_jsx(DetailsTab, Object.assign({
          onTrackInteraction: handleTrackInteraction
        }, details))
      });
    }
    if (Object.values(support || {}).some(Boolean)) {
      tabsArray.push({
        tabId: 'support',
        title: unescapedText('detailsPage.infoCard.support'),
        content: /*#__PURE__*/_jsx(SupportTab, Object.assign({
          onTrackInteraction: handleTrackInteraction
        }, support))
      });
    }
    if (legal) {
      tabsArray.push({
        tabId: 'legal',
        title: unescapedText('detailsPage.infoCard.legal.header'),
        content: /*#__PURE__*/_jsx(LegalTab, Object.assign({
          onTrackInteraction: handleTrackInteraction
        }, legal))
      });
    }
    return tabsArray;
  }, [details, handleTrackInteraction, support, legal]);
  if (tabs.length === 0) {
    return null;
  }
  return /*#__PURE__*/_jsx(DetailsPageCard, {
    id: "product-info-card",
    name: "info card",
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "detailsPage.infoCard.title"
    }),
    children: tabs.length > 1 ? /*#__PURE__*/_jsx(Tabs, {
      defaultSelected: tabs[0].tabId,
      "data-test-id": "info-card-tabs",
      children: tabs.map(tab => /*#__PURE__*/_jsx(Tab, {
        tabId: tab.tabId,
        title: tab.title,
        children: tab.content
      }, tab.tabId))
    }) : /*#__PURE__*/_jsx("div", {
      children: tabs[0].content
    })
  });
}